import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const ChatIcon = observer('ChatIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='#061A32'
            className={className}
            onClick={onClick}
        >
            <path
                d='M8.52404 2H18.9712C20.6442 2 22 3.28846 22 4.875V12.9663C22 14.5529 20.6442 15.8462 18.9712 15.8462H18.1538V18.9231L14.5625 16.0481C14.4423 15.9567 14.2212 15.8462 13.7212 15.8462H8.86058C7.19231 15.8462 5.84615 14.5529 5.84615 12.9615V4.875C5.84615 3.28846 6.85577 2 8.52404 2Z'
                fill='fill'
            />
            <path
                d='M12.9904 17.0481C13.4856 17.0481 13.7067 17.1779 13.8317 17.2644L15.0769 18.1538C14.8606 19.1442 13.6875 19.6923 12.5817 19.6923H8.26442C7.88462 19.6923 7.72115 19.7692 7.62981 19.8365L5.07692 22V19.6923H4.29327C3.02885 19.6923 2 18.9423 2 17.7404V11.5433C2 10.3413 2.95673 9.35577 4.22115 9.35577H4.30769V14.2019C4.30769 15.7933 5.74038 17.0481 7.40865 17.0481H12.9904Z'
                fill='fill'
            />
        </SvgElement>
    );
});
